import { useContext, useEffect, useState } from "react";
import { MarkDocumentRead } from "../../utils/Api/api";
import parser from "html-react-parser";
import "./qa.scss";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Link, Element} from "react-scroll";
import { InView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import { PageRoutes } from "../../utils/pageRoutes";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { ArrowLeft } from "lucide-react";

const Qa = () => {
  const [topicsToogle, setTopicsToogle] = useState(false);
  const [topicText, setTopicText] = useState("GENERAL");
  const navigator = useNavigate();
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const { userLoginData, setAccessDoc, setUserLoginData, accessDoc } =
    useContext(Context);
  const topics = [
    "GENERAL",
    "FOUNDERS",
    "TEAM",
    "CAP TABLE",
    "EXIT",
    "FINANCE & METRICS",
    "MARKET & COMPETITION",
    "HISTORY & STRUCTURE",
  ];
  const loaction = useGeoLocation();
  const [htmlString, setHtmlStr] = useState([]);

  const scrollToSection = (index: number) => {
    const element = document.getElementById(`btn-${index}`);
    if (element) {
      const offset = 250; // The offset in pixels
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth", // This enables smooth scrolling
      });
    }
  };
  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "9431",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["9431"] !== "de") {
      if (accessDoc["9431"] == "ALLOWED") {
        readDoc();
        fetchCmsContent();
      } else {
        navigator("/");
      }
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    document.title = "TICCA | Q&A";
    window.scrollTo(0, 0);
  }, [userLoginData.status, accessDoc]);

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "9431",
      });
    } catch (error) {}
  };

  return (
    <>
      <div className="insights-ir-team-main-dev">
        <div className="insights-ir-team-dev">
          <div className="insights-it-title-dev">
            <h1>Insights from our IR Team</h1>
            <p>Q&A for Investors</p>
          </div>
        </div>
        <hr />
        <div className="insights-ir-team-topic-main-dev">
          <div className="insights-it-team-qa-menu">
            <div
              style={{ background: "white", position: "sticky", top: "85px" }}
            >
              <p className="insights-it-team-qa-title">Topics</p>
              <div className="insights-it-team-btn-dev">
                {topics.map((topic: string, index: number) => (
                  <button
                    key={index}
                    onClick={() => {
                      scrollToSection(index);
                      setTopicsToogle(!topicsToogle);
                      setTopicText(topic);
                    }}
                    className={`button ${topicText == topic && "active-btn"}`}
                  >
                    <span>{topic}</span>
                  </button>
                ))}
              </div>
            </div>
            <div className="content-dev">
              {htmlString.length > 2
                ? htmlString.map((elem: string, index: number) => (
                    <InView
                      key={`content-dev-${index}`}
                      threshold={0.2} // Adjust threshold to 0.5 for testing
                      rootMargin="0% 0% -5% 0%" // Adjust rootMargin if needed
                      // delay={500}
                      onChange={(inView) => {
                        if (inView) {
                          setTopicText(topics[index]);
                        }
                      }}
                    >
                      {" "}
                      <div
                        key={index}
                        id={`btn-${index}`}
                        className={`btn-${index}`}
                      >
                        {parser(elem)}
                      </div>
                    </InView>
                  ))
                : [0, 0, 0, 0, 0, 0, 0, 0].map(
                    (elem: number, index: number) => (
                      <>
                        <ShimmerLoaderwhite maxWidth="100vw" />
                      </>
                    )
                  )}
            </div>
          </div>
        </div>
      </div>
      <div className="insigths-ir-team-main-mobile-dev">
        <div className="insights-it-title-dev">
          <h1>Insights from our IR Team</h1>
          <p>Q&A for Investors</p>
        </div>
        <div className="insigths-ir-team-content-dev">
          <div className="search-dev">
            <samp
              onClick={() => setTopicsToogle(!topicsToogle)}
              className="search-selected-icon"
            >
              {topicsToogle ? (
                <img
                  src="https://public.ticca.com/images/svg/Topic_List_Unclicked.svg"
                  alt="close"
                  width="25px"
                  height="25px"
                />
              ) : (
                <img
                  src="https://public.ticca.com/images/svg/Topic_List_Clicked.svg"
                  alt="open"
                  width="25px"
                  height="25px"
                />
              )}
            </samp>
            {/* <input type="text" placeholder="Search.." id="myInput" /> */}
          </div>
          <hr />
          {topicsToogle && (
            <div className="btn-abou-dev">
              <div className="topics-container">
                <h3>Topics</h3>
                <div className="button-grid">
                  {topics.map((topic: string, index: number) => (
                    <Link
                      offset={-460}
                      to={`btn-${index}`}
                      smooth={true}
                      duration={500}
                    >
                      <button
                        onClick={() => {
                          setTopicsToogle(!topicsToogle);
                          setTopicText(topic);
                        }}
                        className={`button ${
                          topicText == topic && "active-btn"
                        }`}
                        key={index}
                      >
                        <span>{topic}</span>
                      </button>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
          <div className="content-dev">
            {htmlString.length > 1
              ? htmlString.map((elem: string, index: number) => (
                  <Element name={`btn-${index}`} className={`btn-${index}`}>
                    {parser(elem)}
                  </Element>
                ))
              : [0, 0, 0, 0, 0, 0, 0, 0].map((elem: number, index: number) => (
                  <>
                    <ShimmerLoaderwhite />
                  </>
                ))}
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center py-10">
        <div className="w-full max-w-[520px] px-2 flex flex-row items-center gap-3">
          {/* Back Button */}
          <div className="relative group w-1/2">
            <button
              onClick={() => {
                navigator(PageRoutes.Intro);
              }}
              className="
              w-full flex items-center justify-center gap-2 px-4 py-3 rounded-2xl
              bg-white text-gray-700 font-semibold shadow-md
              border border-gray-200
              hover:shadow-lg hover:bg-gray-50
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
            >
              <>
                <ArrowLeft size={18} />
                Back
              </>
            </button>

            {/* Tooltip */}
            <div
              className="
              hidden md:block absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
            >
              Intro
            </div>
          </div>

          {/* Next Button */}
          <div className="relative group w-1/2">
            <button
              onClick={() => {
                navigator(PageRoutes.question);
              }}
              className="
              w-full flex items-center justify-center gap-2 px-4 py-3 rounded-2xl
              bg-gradient-to-r from-blue-600 to-cyan-400
              text-white font-semibold shadow-md
              hover:shadow-xl hover:scale-[1.02]
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
            >
              <>Talk to our CEO</>
            </button>

            {/* Tooltip */}
            <div
              className="
              hidden md:block absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
            >
              Talk to our CEO
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Qa;
